/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import idIcon from "../../assets/icons/progress/icon_progressbar_personal_data.svg";
import divorceIcon from "../../assets/icons/progress/icon_progressbar_divorce.svg";
import financeIcon from "../../assets/icons/progress/icon_progressbar_finance.svg";

const progressBarsteps = [
  {
    key: "divorce",
    name: "Ehe und Scheidung",
    icon: divorceIcon,
  },
  {
    key: "finance",
    name: "Finanzen",
    icon: financeIcon,
  },
  {
    key: "personal",
    name: "Persönliche Angaben",
    icon: idIcon,
  },
];

export default progressBarsteps;
